import { screeningsClient } from '../screeningsClient';
import { ScreeningCustomStep } from '../../models/screeningCustomStep';

export const getScreeningCustomSteps = async (params = {}) => {
  try {
    const { data } = await screeningsClient.get('/screening-custom-steps', {
      params: {
        ...params,
        populateTestGroups: true,
        populateScreenings: true,
      },
    });
    return data.map((step) => new ScreeningCustomStep(step));
  } catch (err) {
    return [];
  }
};

export const getScreeningCustomStepById = async (id) => {
  try {
    const { data } = await screeningsClient.get(`/screening-custom-steps/${id}`, {
      params: {
        populateTestGroups: true,
        populateScreenings: true,
      },
    });
    return new ScreeningCustomStep(data);
  } catch (err) {
    return null;
  }
};

export const createScreeningCustomStep = async (customStep) => {
  const { data } = await screeningsClient.post('/screening-custom-steps', customStep);
  return new ScreeningCustomStep(data);
};

export const updateScreeningCustomStep = async (id, customStep) => {
  const { data } = await screeningsClient.patch(`/screening-custom-steps/${id}`, customStep);
  return new ScreeningCustomStep(data);
};

export const deleteScreeningCustomStep = async (id) => {
  await screeningsClient.delete(`/screening-custom-steps/${id}`);
  return true;
};

export const bulkCreateScreeningCustomSteps = async (customSteps) => {
  const { data } = await screeningsClient.post('/screening-custom-steps/bulk', customSteps);
  return data.map((step) => new ScreeningCustomStep(step));
};

export const bulkDeleteScreeningCustomSteps = async (ids) => {
  await screeningsClient.post('/screening-custom-steps/bulk-delete', ids);
  return true;
};

export const getScreeningCustomStepByPriority = async (
  step,
  workspaceId,
  screeningId,
  testGroupGrouperKey
) => {
  try {
    const params = {
      workspaceId,
      ...(screeningId && { screeningId }),
      ...(testGroupGrouperKey && { testGroupGrouperKey }),
      populateTestGroups: true,
      populateScreenings: true,
    };
    const { data } = await screeningsClient.get(`/screening-custom-steps/priority/${step}`, {
      params,
    });
    return data ? new ScreeningCustomStep(data) : null;
  } catch (err) {
    return null;
  }
};

export const duplicateScreeningCustomStepsForWorkspace = async (
  sourceWorkspaceId,
  targetWorkspaceId
) => {
  const { data } = await screeningsClient.post('/screening-custom-steps/duplicate-workspace', {
    sourceWorkspaceId,
    targetWorkspaceId,
  });
  return data.map((step) => new ScreeningCustomStep(step));
};
